import { render, staticRenderFns } from "./CustomTableItem.vue?vue&type=template&id=77f1382c&scoped=true"
import script from "./CustomTableItem.vue?vue&type=script&lang=js"
export * from "./CustomTableItem.vue?vue&type=script&lang=js"
import style0 from "./CustomTableItem.vue?vue&type=style&index=0&id=77f1382c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f1382c",
  null
  
)

export default component.exports